import { isArray } from "lodash-es";

export const getCampaignData = (campaigns = []) => {
  if (!isArray(campaigns)) {
    return [];
  }
  let campaignData = [];
  campaigns.forEach((data) => {
    if (data.campaign.name !== "PlutusPendingTransactionCampaign") {
      campaignData.push(data);
    }
  });
  return campaignData;
};
